import { useEffect, useState } from "react";

const consentStorageKey = "urban-motors-analytics-consent";

function removeAnalyticsCookies(measurementId) {
  const cookieNames = ["_ga", `_ga_${measurementId.replace("G-", "")}`];
  cookieNames.forEach((name) => {
    document.cookie = `${name}=; Max-Age=0; path=/; SameSite=Lax`;
  });
  document.getElementById("urban-motors-ga4")?.remove();
}

function loadAnalytics(measurementId) {
  if (!measurementId || document.getElementById("urban-motors-ga4")) return;
  window[`ga-disable-${measurementId}`] = false;
  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    window.dataLayer.push(arguments);
  };
  window.gtag("js", new Date());
  window.gtag("config", measurementId, { anonymize_ip: true });

  const script = document.createElement("script");
  script.async = true;
  script.id = "urban-motors-ga4";
  script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(measurementId)}`;
  document.head.appendChild(script);
}

export default function CookieConsent() {
  const measurementId = process.env.REACT_APP_GA_MEASUREMENT_ID;
  const [consent, setConsent] = useState(() => window.localStorage.getItem(consentStorageKey));
  const [isOpen, setIsOpen] = useState(() => !window.localStorage.getItem(consentStorageKey));

  useEffect(() => {
    if (consent === "granted") loadAnalytics(measurementId);
    if (consent === "denied" && measurementId) {
      window[`ga-disable-${measurementId}`] = true;
      removeAnalyticsCookies(measurementId);
    }
  }, [consent, measurementId]);

  const saveConsent = (value) => {
    window.localStorage.setItem(consentStorageKey, value);
    setConsent(value);
    setIsOpen(false);
  };

  return (
    <>
      {isOpen && (
        <section className="cookie-consent" data-testid="cookie-consent-banner" role="dialog" aria-label="Valg for informasjonskapsler">
          <p data-testid="cookie-consent-heading">Analyse og personvern</p>
          <span data-testid="cookie-consent-description">Vi bruker valgfri analyse for å forstå hvordan nettsiden brukes.</span>
          <div className="cookie-consent__actions" data-testid="cookie-consent-actions">
            <button className="cookie-consent__decline" data-testid="cookie-consent-decline-button" onClick={() => saveConsent("denied")}>Avslå</button>
            <button className="cookie-consent__accept" data-testid="cookie-consent-accept-button" onClick={() => saveConsent("granted")}>Godta analyse</button>
          </div>
        </section>
      )}
      {!isOpen && (
        <button className="cookie-preferences-button" data-testid="cookie-preferences-button" onClick={() => setIsOpen(true)}>Cookievalg</button>
      )}
    </>
  );
}